export class NICEDNCContributingSkills {
    totalRecords: number;
    skillId: number;
    skillName: string;

    constructor(dncJSON?: any) {
        if (dncJSON) {
            this.totalRecords = dncJSON.totalRecords || 0;
            this.skillId = dncJSON.skillId || 0;
            this.skillName = dncJSON.skillName || '';
        } else {
            this.totalRecords = 0;
            this.skillId = 0;
            this.skillName = '';
        }
    }
}
